export enum OrderChangeEvent {
  STATUS_CHANGE = 'STATUS_CHANGE',
  ORDER_VALIDATION = "ORDER_VALIDATION",
}
